import { Table } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { type PorschePaymentModuleSpecsFragment } from '../../../../api/fragments/PorschePaymentModuleSpecs';
import PorschePaymentSettingActions from './PorschePaymentSettingActions';

export type PorschePaymentSettingsTableProps = {
    module: PorschePaymentModuleSpecsFragment;
};

export type PaymentSettingSpecs = PorschePaymentModuleSpecsFragment['paymentSettings'][number];

const PorschePaymentSettingsTable = ({ module }: PorschePaymentSettingsTableProps) => {
    const { t } = useTranslation(['porschePaymentModuleDetails']);

    const renderActions = useCallback(
        (record: PaymentSettingSpecs) => <PorschePaymentSettingActions module={module} paymentSetting={record} />,
        [module]
    );

    return (
        <Table dataSource={module.paymentSettings} rowKey="id">
            <Table.Column
                key="displayName"
                dataIndex="displayName"
                title={t('porschePaymentModuleDetails:paymentSettingsTable.columns.displayName')}
            />
            <Table.Column
                key="currency"
                dataIndex="currency"
                title={t('porschePaymentModuleDetails:paymentSettingsTable.columns.currency')}
            />
            <Table.Column
                key="amount"
                dataIndex="amount"
                title={t('porschePaymentModuleDetails:paymentSettingsTable.columns.amount')}
            />
            <Table.Column
                key="environment"
                dataIndex="environment"
                title={t('porschePaymentModuleDetails:paymentSettingsTable.columns.environment')}
            />
            <Table.Column
                key="actions"
                align="center"
                render={renderActions}
                title={t('porschePaymentModuleDetails:paymentSettingsTable.columns.actions')}
                width={100}
            />
        </Table>
    );
};

export default PorschePaymentSettingsTable;
